import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title=""
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="SSENSE Website Clone"
          des="It's a group project which takes 4-5 days to complete. The Objective of SSENSE Website Clone is to provide products through online."
          src={projectOne} href='https://www.ssense.com/en-in' githref='https://github.com/Rash6/ssense.com'
        />
        <ProjectsCard
          title="Booking.com Website Clone"
          des=" This is a group project with 5 teammembers. Booking.com has grown from a small Dutch start-up to one of the world’s leading digital travel companies."
          src={projectTwo} href='https://booking-com-clone-nikhilsingh38.vercel.app/' githref='https://github.com/nikhilsingh38/Booking.com_clone.git'
        />
        
        <ProjectsCard
          title="Product Website Clone"
          des=" This is an individual project.Heving multiple functionalities. Currently working on this project."
          src={projectThree} href='https://react-bootstrap-app-lu7b.vercel.app/' githref='https://github.com/Soubhagya118/react-bootstrap-app/tree/main'
        />
      
      </div>
    </section>
  );
}

export default Projects